import SliderImageWithText, { SliderImageWithTextProps } from './SliderImageWithText'
export default SliderImageWithText
export { SliderImageWithText, SliderImageWithTextProps }
